// Generated Module Configuration
export const moduleConfig = {
  "moduleConfig": {
    "name": "New Module",
    "description": "",
    "size": "medium",
    "theme": "uplynk",
    "endpoints": [
      {
        "root_url": "https://services.uplynk.com/api/v4",
        "path": "/ingest/external/jobs",
        "method": "POST",
        "category": "Smartplay Ingest",
        "parameters": {
          "job_type": {
            "type": "string",
            "examples": "live",
            "required": true,
            "help": "External ingest job type",
            "displayName": "Live / VOD",
            "placeholder": "",
            "helpText": "",
            "inputElement": "select"
          },
          "slicer_id": {
            "type": "string",
            "examples": "aws_ingest",
            "required": true,
            "help": "Ingest Live: slicer_id / Ingest Vod: vod_slicer",
            "displayName": "Give it a unique ID",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "url": {
            "type": "string",
            "examples": "https://c4af3793bf76b33c.mediapackage.us-west-2.amazonaws.com/out/v1/a2a60bf0d27049058a175a3f968ded34/index.m3u8",
            "required": true,
            "help": "BYOE ExternalIngestJob Description",
            "displayName": "URL to Pull from",
            "placeholder": "",
            "helpText": "",
            "inputElement": "textarea"
          },
          "desc": {
            "type": "string",
            "examples": "BYOE ExternalIngestJob",
            "required": false,
            "help": "BYOE ExternalIngestJob Description",
            "displayName": "Hidden - Match to Channel - desc",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "persist_segments": {
            "type": "boolean",
            "examples": "false",
            "required": false,
            "help": "Boolean flag that determines if segments should be persisted to cloud storage",
            "displayName": "Store Segments",
            "placeholder": "",
            "helpText": "",
            "inputElement": "checkbox"
          },
          "metadata": {
            "type": "object",
            "examples": {
              "external_id": "",
              "drm_mode": "none",
              "meta": {}
            },
            "required": false,
            "help": "Live or VOD External Ingest",
            "displayName": "metadata",
            "placeholder": "",
            "helpText": "",
            "inputElement": "json"
          },
          "state": {
            "type": "string",
            "examples": "NEW",
            "required": false,
            "help": "Set Desired State, NEW, SCHEDULED",
            "displayName": "state - hidden",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          }
        }
      }
    ],
    "callbacks": {
      '/ingest/external/jobs': {
        "afterResponse": {
          "actions": [
            {
              "action": 'appendState',
              "config": {
                "state": 'done',
                "messageTemplate": {"title": "Created Job", "value": "{ingest_id}"},
                "extractMapping": {
                  "ingest_id": 'data.id',
                  "progress": 100
                }
              }
            },
            {
              "action": 'updateSharedParams',
              "config": {
                "extractMapping": {
                  "channel_created": "data.created",
                  "playerURL": "https://content.uplynk.com/ext/{data.owner}/{data.metadata.external_id}.m3u8",
                  "job_id": "data.id"
                }
              }
            }
          ]
        },
        "onError": {
          "actions": [
            // Error handling actions
            {
              "action": 'sendNotification',
              "config": {
                "message": 'Cloud Slicer API Error: {value}',
                "type": 'error',
                "extractPath": 'error.error_message'
              }
            },
            {
              "action": 'appendState',
              "config": {
                "state": 'error',
                "messageTemplate": {"title": "Create Failed", "value": "{errorMessage}"},
                "extractMapping": {
                  "errorMessage": 'error.message',
                  "progress_percent": 0
                }
              }
            }
          ]
        }
      }
    },
    "elements": []
  },
  "displayOrder": [
    {
      "endpointIndex": 0,
      "paramName": "job_type"
    },
    {
      "endpointIndex": 0,
      "paramName": "slicer_id"
    },
    {
      "endpointIndex": 0,
      "paramName": "url"
    },
    {
      "endpointIndex": 0,
      "paramName": "desc"
    },
    {
      "endpointIndex": 0,
      "paramName": "persist_segments"
    },
    {
      "endpointIndex": 0,
      "paramName": "metadata"
    },
    {
      "endpointIndex": 0,
      "paramName": "state"
    },
    {
      "type": "button",
      "elementId": "button_1742305595821"
    }
  ],
  "customElements": [
    {
      "id": "button_1742305595821",
      "type": "button",
      "label": "Apply",
      "variant": "primary",
      "action": "submit"
    }
  ]
};